import { render, staticRenderFns } from "./ConnectionsAdmin.vue?vue&type=template&id=6f012b0b"
import script from "./ConnectionsAdmin.vue?vue&type=script&lang=js"
export * from "./ConnectionsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports